import React, { useState } from 'react'

import type { ConfirmModalProps } from '@fourthwall/components'
import { ConfirmModal, Fieldset, RadioButton } from '@fourthwall/components'

import * as S from './PaymentMethodRecommendedModal.styled'

type PaymentMethodChoice = 'ADD' | 'SKIP'

type Props = Omit<ConfirmModalProps, 'onConfirm'> & {
  onConfirm: (paymentMethodChoice: PaymentMethodChoice) => void
}

export const PaymentMethodRecommendedModal = (props: Props) => {
  const [paymentMethodChoice, setPaymentMethodChoice] = useState<PaymentMethodChoice>('ADD')

  return (
    <ConfirmModal
      {...props}
      text={
        <>
          {props.text}
          <S.RadioButtonsContainer>
            <Fieldset>
              <Fieldset.Row>
                <RadioButton
                  checkedValue="ADD"
                  value={paymentMethodChoice}
                  label="Yes, allow promotions to be redeemed that result in negative profit (payment method required)"
                  onChange={(event) =>
                    setPaymentMethodChoice(event.target.value as PaymentMethodChoice)
                  }
                />
              </Fieldset.Row>
              <Fieldset.Row>
                <RadioButton
                  checkedValue="SKIP"
                  value={paymentMethodChoice}
                  label="No, block redemptions of promotions that would result in negative profit"
                  suggestion={
                    <>
                      Promotion redemptions will be blocked only if they would result in negative
                      profit that can't be covered by your account balance.
                    </>
                  }
                  onChange={(event) =>
                    setPaymentMethodChoice(event.target.value as PaymentMethodChoice)
                  }
                />
              </Fieldset.Row>
            </Fieldset>
          </S.RadioButtonsContainer>
        </>
      }
      onConfirm={() => props.onConfirm(paymentMethodChoice)}
    />
  )
}
